<template>
  <section
    class="public-page"
    :class="isCalendarPage ? 'public-page--calendar' : ''"
  >
    <div class="content">
      <PublicHeader v-if="!isCalendarPage" />
      <div class="content__inner">
        <slot />
      </div>
      <PublicCta
        v-if="breakpointSmallerLg && !isCalendarPage"
        class="text-center mb-6"
      />
      <PublicFooter v-if="!isCalendarPage" />
    </div>

    <PublicEmergency v-if="$i18n.locale !== 'ua' && !isCalendarPage" />

    <ConfirmEmergencyDialog />
    <ConfirmAnonymousRequestDialog />
  </section>
</template>

<script setup>
// Refs
const route = useRoute();
const i18n = useI18n();

// Computed
const breakpointSmallerLg = useBreakpoint.smaller('lg');
const isCalendarPage = computed(() => useRoute()?.name?.includes('kalendar-type'));

// Watchers
watch(() => useAuthStore().isLoggedIn, () => {
  if (useAuthStore().isLoggedIn && !route.name?.includes('kalendar-type')) {
    return navigateTo('/');
  }
}, { immediate: true });

// Lifecycle
onMounted(() => {
  if (useRoute().query.organization) {
    const organizationUUID = useRoute().query.organization;

    if (useAuthStore().isLoggedIn) {
      useAuthStore().logout();
    }

    if (useRoute().query.qr) {
      useDialogStore().anonymousRequest.isFromQR = true;
    }

    useDialogStore().open('anonymousRequest');
    useDialogStore().anonymousRequest.organizationUUID = organizationUUID;
    useDialogStore().anonymousRequest.isFromQR = Boolean(useRoute().query.qr);
  }

  const browserLanguage = navigator.language || navigator.userLanguage;

  if (browserLanguage === 'uk-UA') {
    i18n.setLocale('ua');
  }
});
</script>
